import React from 'react';
import { ContentContainer } from '../../_sections/Content/ContentContainer';
import { ContextSection } from '../../_sections/Context/ContextSection';
import { SectionWithWidgets } from '../../types/api/Sections';

type StandardProps = {
  contentSection: SectionWithWidgets;
  contextSection?: ContextSection;
  contentMultiColumn?: any | undefined;
};

/**
 * Renders the StandardLayout Layout, which contains Content and Context Section.
 * Context section can be empty, but still Content section is not displayed in full width.
 */
export function StandardLayout({ contentSection, contentMultiColumn, contextSection }: StandardProps) {
  return (
    <>
      <ContentContainer
        className="content-column-two-third"
        section={contentSection}
        contentMultiColumn={contentMultiColumn}
      />
      {contextSection && <ContextSection {...contextSection} />}
    </>
  );
}
